// Vaste link naar de Arenal Academy-app (linktype "Academy-app" in modules/linkresolver).
//   #academy-app → mobiel: probeer de app te openen, anders de webversie; desktop: webversie.
// Een URL-schema geeft geen foutmelding als de app ontbreekt: wordt de pagina binnen de
// timeout niet verborgen (visibilitychange/pagehide), dan gaan we uit van "niet geïnstalleerd".

const HREF = "#academy-app";
const APP_URL = "traininarenal-academy://";
const WEB_URL = "https://arenal-academy.trainin.app";
const TIMEOUT = 1500;

const isMobile = () => /android|iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

function openAcademy() {
	if (!isMobile()) {
		window.open(WEB_URL, "_blank", "noopener");
		return;
	}

	let left = false;
	const markLeft = () => {
		if (document.hidden) left = true;
	};
	// Enkel visibilitychange/pagehide: `blur` vuurt ook bij de foutmelding van Safari ("adres ongeldig")
	// als de app ontbreekt, waardoor de fallback dan ten onrechte niet zou starten.
	document.addEventListener("visibilitychange", markLeft);
	window.addEventListener("pagehide", () => (left = true), { once: true });

	window.location.href = APP_URL;

	window.setTimeout(() => {
		document.removeEventListener("visibilitychange", markLeft);
		if (!left) window.location.href = WEB_URL;
	}, TIMEOUT);
}

document.addEventListener("click", (e) => {
	const link = e.target.closest?.('a[href="' + HREF + '"]');
	if (!link) return;
	e.preventDefault();
	openAcademy();
});
